// extracted by mini-css-extract-plugin
export default {"wrapper":"QrZoPwZqAngI4iBuXSwe","label":"UB3VMg0LXSvdmj3XV4l9","input":"tpRD60XNP2uXSf426Hxq"};